module.exports = __webpack_public_path__ + "static/media/china-ems.ef1dc139.svg";